import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import ListingsApprove from './ListingsApprove';
import { restrictUrls } from '../../../helpers/adminPrivileges';


const title = 'Listings Approve';

export default {

  path: '/siteadmin/listings/approve',

  async action({ store }) {


    // From Redux Store
    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().adminPrevileges.privileges && store.getState().adminPrevileges.privileges.privileges;

    if (!isAdminAuthenticated) {
      return { redirect: '/siteadmin/login' };
    }

    // Admin restriction
    if (!restrictUrls('/siteadmin/listings/approve', adminPrivileges)) {
      
      return { redirect: '/siteadmin' };
    }

    return {
      title,
      component: <AdminLayout><ListingsApprove title={title} /></AdminLayout>,
    };
  },

};
